export const FEATURE_FLAGS_WHITELIST = ["Example", "Attachments"] as const
